import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";

import Landing from "./pages/Landing";
import SchoolSignup from "./pages/SchoolSignup";
import Login from "./pages/Login";
import ResetPassword from "./pages/ResetPassword";
import SuperAdminDashboard from "./pages/SuperAdminDashboard";
import SchoolAdminDashboard from "./pages/SchoolAdminDashboard";
import TeacherDashboard from "./pages/TeacherDashboard";
import StudentPortal from "./pages/StudentPortal";
import PrintResultCard from "./pages/PrintResultCard";
import PrintPortalResultCard from "./pages/PrintPortalResultCard";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/register" element={<SchoolSignup />} />
          <Route path="/login" element={<Login />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/portal/:schoolId" element={<StudentPortal />} />
          <Route path="/portal" element={<StudentPortal />} />

          <Route path="/super-admin" element={
            <ProtectedRoute roles={["super_admin"]}><SuperAdminDashboard /></ProtectedRoute>
          } />
          <Route path="/school-admin" element={
            <ProtectedRoute roles={["school_admin"]}><SchoolAdminDashboard /></ProtectedRoute>
          } />
          <Route path="/teacher" element={
            <ProtectedRoute roles={["teacher"]}><TeacherDashboard /></ProtectedRoute>
          } />

          <Route path="/print/student/:studentId/exam/:examId" element={<PrintResultCard />} />
          <Route path="/print/class/:classSectionId/exam/:examId" element={<PrintResultCard />} />
          <Route path="/portal-print/:examId" element={<PrintPortalResultCard />} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
